import { useGetLmsTrainingReportsQuery } from '../../../../api';

// `skip`/yükleme sırasında her render'da yeni literal dönmesin diye modül seviyesinde sabit.
const EMPTY_LIST = { items: [], totalCount: 0 };

/**
 * Eğitim Raporları liste sayfası için veri hook'u. Kaydet/sil mutasyonları artık ayrı
 * bir sayfada (`createEditForm/hook/useTrainingReportMutations.js`) — `TrainingCatalogPage`/
 * `useTrainingCatalogData.js` ile aynı ayrım. Bkz. docs/LMS-Egitim-Raporlari-API.md §3.4.
 */
const useTrainingReportsData = () => {
    const {
        data: reportsApi,
        isLoading,
        isFetching,
        refetch
    } = useGetLmsTrainingReportsQuery({ pageNumber: 1, pageSize: 100 }, { refetchOnMountOrArgChange: true });

    return {
        reportsApi: reportsApi || EMPTY_LIST,
        isLoading,
        isFetching,
        refetch
    };
};

export default useTrainingReportsData;
